export default {
    'name': 'dragndrop',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M11.3995 5.04862C11.5948 4.85336 11.5948 4.53678 11.3995 4.34151C11.2043 4.14625 10.8877 4.14625 10.6924 4.34151L4.34151 10.6924C4.14625 10.8877 4.14625 11.2043 4.34151 11.3995C4.53678 11.5948 4.85336 11.5948 5.04862 11.3995L11.3995 5.04862ZM12.5203 8.41087C12.7156 8.21561 12.7156 7.89903 12.5203 7.70377C12.325 7.50851 12.0084 7.50851 11.8132 7.70377L7.70377 11.8132C7.50851 12.0084 7.50851 12.325 7.70377 12.5203C7.89903 12.7156 8.21561 12.7156 8.41087 12.5203L12.5203 8.41087Z\' fill=\'#42A463\'/>'
}
